import type { FieldOptions } from 'vee-validate'
import { useField as useVeeField } from 'vee-validate'
import { defu } from 'defu'
import type { UseFieldOptions } from '../types'
import { useFieldValidator, watch, toValue, useFieldListeners } from '#imports'

export const useField = (options: UseFieldOptions) => {
    const { props, emit, on: onConfig = {}, options: fieldOptions = {} } = options

    const { runValidation } = useFieldValidator({
        rules: () => toValue(props).rules,
    })

    const context = useVeeField(() => toValue(props).name, runValidation, defu<FieldOptions<any>, Partial<FieldOptions<any>>[]>(fieldOptions, { syncVModel: true, validateOnValueUpdate: false }))

    const on = useFieldListeners(context, onConfig)

    watch(() => toValue(props).errorMessages, (errorMessages) => {
        if (errorMessages) {
            context.setErrors(errorMessages)
        }
    }, {
        immediate: true,
    })

    watch(() => context.meta, (meta) => {
        emit('update:meta', meta)
    }, {
        immediate: true,
    })

    return {
        context,
        on,
    }
}
